import React from "react";
import { useDispatch } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import {
  fetch_consultationInititalisation,
  screenstatusupdate,
  finishconsultation,
  fetch_consultationDetails,
} from "../../actions/RPMAction";

import "./Land.scss";
import VideoConsultation from "./components/commonVideoConsultation/VideoConsultation";
// import {
//   PrescriptionProvider,
//   usePrescription,
// } from "./components/commonVideoConsultation/consultation-details/prescription/PrescriptionContext";

const ConsultationManager = ({
  userRole,
  zoomConfig,
  headerData,
  isLoading,
  error,
  onRetry,
  onLeave,
  onPipChange,
  isFloating,
  floatingMode,
  floatingViewMode,
  onFloatingHeightChange,
  appointmentId: propAppointmentId,
}) => {
  const { appointmentId: paramsAppointmentId } = useParams();
  const appointmentId = propAppointmentId || paramsAppointmentId;
  const dispatch = useDispatch();
  const history = useHistory();
  // const { savePrescription } = usePrescription();

  const role = userRole;

  const handleSessionEnd = async (
    sessionData = {},
    isEndByDuplicate = false
  ) => {
    if (role === "Web_Doctor" && !isEndByDuplicate) {
      try {
        const requestData = {
          attachementArrs: [],
          consultationId: appointmentId,
          visitId: localStorage.getItem("visitId") || "",
          isvalid: "No",
          userType:
            role === "Web_Doctor"
              ? "Doctor"
              : role === "Web_Patient"
                ? "Patient"
                : role,
          prescriptionfrom: "RPM",
          consultationDetails: {
            doctor_suggestion: sessionData.doctorSuggestion || "",
            chiefcomplaints: sessionData.chiefComplaints || "",
            diagnosis: sessionData.diagnosis || "",
            investigation: sessionData.investigation || "",
            notes: sessionData.notes || "",
            instruction: sessionData.instruction || "",
            share: true,
            medicine: sessionData.medicine || [],
            labTest: sessionData.labTest || [],
            nextStep: sessionData.nextStep || {},
            privateMessage: sessionData.privateMessage || "",
            height: sessionData.height || "",
            weight: sessionData.weight || "",
            lmp: sessionData.lmp || "",
          },
        };

        const result = await dispatch(finishconsultation(requestData));

        if (result && result.info !== "Data failed to update") {
          console.log("✅ Consultation finished successfully");

          // Trigger savePrescription before navigating to dashboard
          console.log("💾 Saving prescription after ending consultation...");
          // await savePrescription(true); // skipValidation = true

          if (onLeave) {
            onLeave();
          } else {
            history.push({
              pathname: "/dashboard",
              state: {
                appointmentId: appointmentId,
                page: "prescripton",
                consultationData: result,
              },
            });
          }
        } else {
          console.error("❌ Failed to finish consultation");
          if (onLeave) {
            onLeave();
          } else {
            history.push({
              pathname: "/dashboard",
              state: {
                appointmentId: appointmentId,
                error: "Failed to save consultation data",
              },
            });
          }
        }
      } catch (error) {
        console.error("❌ Error finishing consultation:", error);
        if (onLeave) {
          onLeave();
        } else {
          history.push({
            pathname: "/dashboard",
            state: {
              appointmentId: appointmentId,
              error: "Error saving consultation data",
            },
          });
        }
      }
    } else {
      if (onLeave) {
        onLeave();
      } else {
        history.push({
          pathname: "/dashboard",
          state: { appointmentId: appointmentId },
        });
      }
    }
  };

  const handleSessionJoin = async () => {
    if (role === "Web_Doctor") {
      try {
        await dispatch(
          screenstatusupdate("Doctor", appointmentId, "In Consultation Screen")
        );
      } catch (error) {
        console.warn("⚠️ Failed to update screen status on join:", error);
      }
    }
  };

  if (isLoading) {
    return (
      <div className="zoom-full-height">
        <div className="loading-state">
          <div className="loading-content">
            <div className="spinner"></div>
            <p className="loading-text">Initializing consultation...</p>
            <p className="loading-subtext">Setting up your video session</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="zoom-full-height">
        <div className="error-state">
          <div className="error-content">
            <div className="error-icon">❌</div>
            <h3 className="error-title">Connection Error</h3>
            <p className="error-message">{error}</p>
            <div className="error-actions">
              <button onClick={onRetry} className="retry-button">
                Retry
              </button>
              <button
                onClick={() => history.push("/dashboard")}
                className="dashboard-button"
              >
                Go to Dashboard
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!appointmentId) {
    return (
      <div className="zoom-full-height">
        <div className="invalid-appointment">
          <div className="invalid-content">
            <div className="invalid-icon">❌</div>
            <h3 className="invalid-title">Invalid Appointment</h3>
            <p className="invalid-message">
              No appointment ID found in the URL
            </p>
            <button
              onClick={() => history.push("/dashboard")}
              className="dashboard-button"
            >
              Go to Dashboard
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="zoom-full-height">
      {zoomConfig ? (
        <VideoConsultation
          config={zoomConfig}
          role={role}
          headerData={headerData}
          onLeave={handleSessionEnd}
          onJoin={handleSessionJoin}
          onPipChange={onPipChange}
          isFloating={isFloating}
          floatingMode={floatingMode}
          floatingViewMode={floatingViewMode}
          onFloatingHeightChange={onFloatingHeightChange}
        />
      ) : (
        <div className="not-ready-state">
          <div className="not-ready-content">
            <div className="warning-icon">⚠️</div>
            <h3 className="not-ready-title">Consultation Not Ready</h3>
            <p className="not-ready-message">
              The consultation session is not available at the moment.
            </p>
            <div className="not-ready-actions">
              <button onClick={onRetry} className="retry-button">
                Try Again
              </button>
              <button
                onClick={() => history.push("/dashboard")}
                className="dashboard-button"
              >
                Go to Dashboard
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const ConsultationLanding = ({
  userRole = "Web_Doctor",
  appointmentId: propAppointmentId,
  onLeave,
  onPipChange,
  isFloating,
  floatingMode,
  floatingViewMode,
  onFloatingHeightChange,
}) => {
  const { appointmentId: paramsAppointmentId } = useParams();
  const appointmentId = propAppointmentId || paramsAppointmentId;
  const dispatch = useDispatch();

  const [zoomConfig, setZoomConfig] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [headerData, setHeaderData] = React.useState(null);

  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const role = userRole || userData.userType || "Web_Patient";

  const fetchUserData = React.useCallback(async () => {
    if (!appointmentId) {
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      setError(null);

      if (role === "Web_Doctor") {
        await dispatch(
          screenstatusupdate("Doctor", appointmentId, "In Consultation Screen")
        );
      }

      let roleforUrl = role === "Web_Doctor" ? "Doctor" : "Patient";
      let response = await dispatch(
        fetch_consultationInititalisation(appointmentId, roleforUrl)
      );

      if (response) {
        const sessionData = response;
        setZoomConfig({
          sessionName:
            sessionData.sessionId ||
            sessionData.sessionName ||
            sessionData.tokenid,
          sessionToken: sessionData.tokenId || sessionData.token,
          userName: role,
        });
      }

      let headerresponse = await dispatch(
        fetch_consultationDetails(appointmentId, roleforUrl)
      );

      if (headerresponse) {
        setHeaderData(headerresponse);
      } else {
        setHeaderData(null);
      }
    } catch (dispatchError) {
      console.error("❌ Dispatch failed:", dispatchError);
      setError("Failed to initialize consultation");
    } finally {
      setIsLoading(false);
    }
  }, [appointmentId, dispatch, role]);

  React.useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  return (
    <ConsultationManager
      userRole={role}
      zoomConfig={zoomConfig}
      headerData={headerData}
      isLoading={isLoading}
      error={error}
      onRetry={fetchUserData}
      onLeave={onLeave}
      onPipChange={onPipChange}
      appointmentId={appointmentId}
      isFloating={isFloating}
      floatingMode={floatingMode}
      floatingViewMode={floatingViewMode}
      onFloatingHeightChange={onFloatingHeightChange}
    />
  );
};

export const DoctorConsultation = (props) => {
  return <ConsultationLanding userRole="Web_Doctor" {...props} />;
};

export const PatientConsultation = (props) => {
  return (
    <>
      <ConsultationLanding userRole="Web_Patient" {...props} />
    </>
  );
};
export const NurseConsultation = (props) => {
  return (
    <>
      <ConsultationLanding userRole="Web_Nurse" {...props} />
    </>
  );
};

export const SpokeConsultation = (props) => {
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const profileName = userData?.profileName || "";
  return (
    <>
      <ConsultationLanding userRole={`Spoke-${profileName}`} {...props} />
    </>
  );
};
